import Topic from "../../../classes/Topic";
import { db } from "../../../boot/firebase";
import {
  addDoc,
  collection,
  doc,
  setDoc,
  deleteDoc,
  writeBatch,
} from "firebase/firestore";

export const LISTEN_TOPICS = (
  { dispatch },
  { projectID, listenerPath, error, next, unlisten, retain }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Topic,
    stateKey: "topics",
    path: Topic.getPath(projectID),
    listenerPath,
    next,
    error,
    unlisten,
    retain,
  });
};

export const SAVE_TOPIC = async ({ state }, { projectID, topic }) => {
  if (!topic.id) {
    // New Topic
    topic.data.created = new Date();
    topic.data.createdBy = state.user.id;
    const colRef = collection(db, Topic.getPath(projectID)).withConverter(
      Topic
    );
    const docRef = await addDoc(colRef, topic);
    topic.id = docRef.id;
  } else {
    // Existing Topic
    topic.data.modified = new Date();
    topic.data.modifiedBy = state.user.id;
    await setDoc(doc(db, topic.path).withConverter(Topic), topic);
  }
  return topic;
};

export const DELETE_TOPIC = async (context, { projectID, topicID }) => {
  return deleteDoc(doc(db, Topic.getPath(projectID, topicID)));
};

// Filing a message under a topic is not an edit of the message: it leaves
// `modified` alone (which would show "Edited by …") and, per the rules, any
// employee may do it to anyone's message. Replies follow the message they
// answer, all the way down the chain.
export const ASSIGN_MESSAGE_TOPIC = async (
  { state },
  { projectID, messageID, topicID }
) => {
  const messages = Object.values(state.messages).filter(
    (m) => m.projectID === projectID
  );
  const ids = new Set([messageID]);
  for (const id of ids) {
    messages.forEach((m) => {
      if (m.data.replyTo === id) ids.add(m.id);
    });
  }
  const batch = writeBatch(db);
  ids.forEach((id) => {
    batch.update(doc(db, `projects/${projectID}/messages/${id}`), {
      topicID: topicID || null,
    });
  });
  await batch.commit();
};
